import React from "react";
import { makeStyles } from "tss-react/mui";
// import { withPixelLineHeight } from '../../../base/styles/functions.web';
import Button from "../../../base/ui/components/web/Button";
import Checkbox from "../../../base/ui/components/web/Checkbox";
import RadioButton from "../../../base/ui/components/web/RadioButton";
import { BUTTON_TYPES } from "../../../base/ui/constants.web";
import { isSubmitAnswerDisabled } from "../../functions";
import AbstractPollAnswer from "../AbstractPollAnswer";
import { useSelector } from "react-redux";
import { getBrandingColorPalette } from "../../../base/styles/components/styles/ColorPalette.web";
const PollAnswer = ({ creatorName, checkBoxStates, poll, setCheckbox, skipAnswer, skipChangeVote, submitAnswer, t, }) => {
    const { changingVote } = poll;
    const interfaceConfig = useSelector((state => state['features/base/config'].interfaceConfig));
    const useStyles = makeStyles()(() => {
        var _a, _b;
        return {
            container: {
                margin: "24px",
                padding: "16px",
                backgroundColor: interfaceConfig.applyMeetingSettings ? (_a = getBrandingColorPalette(interfaceConfig)) === null || _a === void 0 ? void 0 : _a.background : "#292929",
                borderRadius: "8px",
                wordBreak: "break-word",
            },
            header: {
                marginBottom: "12px",
            },
            question: {
                // ...withPixelLineHeight(theme.typography.heading6),
                color: "#fff",
                // marginBottom: "8px",
            },
            creator: {
                // ...withPixelLineHeight(theme.typography.bodyShortRegular),
                // color: '#C2C2C2'
                color: "#C2C2C2",
                fontWeight: 600,
                // margin: "4px 0 16px 0",
            },
            answerList: {
                listStyleType: "none",
                margin: 0,
                padding: 0,
                marginBottom: "12px",
            },
            answer: {
                display: "flex",
                marginBottom: "16px",
                fontWeight: 400,
                margin: "4px",
                backgroundColor: interfaceConfig.applyMeetingSettings ? (_b = getBrandingColorPalette(interfaceConfig)) === null || _b === void 0 ? void 0 : _b.primary : "#1f1f1f",
                borderRadius: "10px",
                padding: "5px 10px"
            },
            footer: {
                display: "flex",
                justifyContent: "space-between",
            },
            buttonMargin: {
                marginRight: 16,
            },
        };
    });
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.header },
            React.createElement("div", { className: classes.question }, poll.question),
            React.createElement("div", { className: classes.creator }, t("polls.by", { name: creatorName }))),
        React.createElement("ul", { className: classes.answerList }, poll.answers.map((answer, index) => (React.createElement("li", { className: classes.answer, key: index }, poll.pollType === 'single-select' ? (React.createElement(RadioButton, { checked: checkBoxStates[index], key: index, label: answer.name, name: "poll-answer", onChange: (ev) => setCheckbox(index, ev.target.checked), value: index.toString() })) : (React.createElement(Checkbox, { checked: checkBoxStates[index], key: index, label: answer.name, onChange: (ev) => setCheckbox(index, ev.target.checked) })))))),
        React.createElement("div", { className: classes.footer },
            React.createElement(Button, { accessibilityLabel: t("polls.answer.skip"), 
                // className = { classes.buttonMargin }
                className: "poll-button poll-button-secondary poll-button-shortest", labelKey: "polls.answer.skip", onClick: changingVote ? skipChangeVote : skipAnswer, type: BUTTON_TYPES.SECONDARY }),
            React.createElement(Button, { className: "poll-button poll-button-primary poll-button-shortest", accessibilityLabel: t("polls.answer.submit"), disabled: isSubmitAnswerDisabled(checkBoxStates, poll.pollType), labelKey: "polls.answer.submit", onClick: submitAnswer }))));
};
/*
 * We apply AbstractPollAnswer to fill in the AbstractProps common
 * to both the web and native implementations.
 */
export default AbstractPollAnswer(PollAnswer);
